import { Link } from "react-router-dom";
import { LOGO_SRC, BRANDS } from "@/data/content";
import { SITE } from "@/config/site";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t, lp } = useLanguage();

  const links = [
    { to: "/", label: t("nav.home"), id: "home" },
    { to: "/a-igniva", label: t("nav.about"), id: "about" },
    { to: "/marcas", label: t("nav.brands"), id: "brands" },
    { to: "/aplicacoes", label: t("nav.applications"), id: "applications" },
    { to: "/explorador", label: t("nav.explorer"), id: "explorer" },
    { to: "/profissionais", label: t("nav.professionals"), id: "professionals" },
    { to: "/contactos", label: t("nav.contacts"), id: "contacts" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0C0D0F] text-[#A8A6A0]">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-12 gap-10">
        <div className="col-span-2 md:col-span-4">
          <Link to={lp("/")} aria-label="IGNIVA — Início" data-testid="footer-logo-link">
            <img src={LOGO_SRC} alt="IGNIVA — The Art of Surfaces" className="h-12 w-auto mb-6" width="312" height="134" loading="lazy" decoding="async" />
          </Link>
          <p className="text-sm font-light leading-relaxed max-w-sm">{t("footer.tagline")}</p>
        </div>

        <div className="md:col-span-3">
          <span className="mono-tag block text-[11px] uppercase tracking-[0.22em] text-[#C2A675] mb-5">{t("footer.nav")}</span>
          <ul className="space-y-2.5 text-sm font-light">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={lp(l.to)} className="hover:text-white transition-colors" data-testid={`footer-nav-${l.id}`}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <span className="mono-tag block text-[11px] uppercase tracking-[0.22em] text-[#C2A675] mb-5">{t("footer.brands")}</span>
          <ul className="space-y-2.5 text-sm font-light">
            {BRANDS.map((b) => (
              <li key={b.slug}>
                <Link to={lp(`/marcas/${b.slug}`)} className="hover:text-white transition-colors" data-testid={`footer-brand-${b.slug}`}>{b.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-2 md:col-span-3">
          <span className="mono-tag block text-[11px] uppercase tracking-[0.22em] text-[#C2A675] mb-5">{t("footer.contact")}</span>
          <a href={`mailto:${SITE.email}`} className="block text-sm font-light text-[#E8E6E1] hover:text-[#C2A675] transition-colors" data-testid="footer-email-link">
            {SITE.email}
          </a>
          <a href={SITE.phoneHref} className="block mt-2 text-sm font-light text-[#E8E6E1] hover:text-[#C2A675] transition-colors" data-testid="footer-phone-link">
            {SITE.phone}
          </a>
          <Link to={lp("/privacidade")} className="block mt-6 text-xs underline underline-offset-4 hover:text-white transition-colors" data-testid="footer-privacy-link">
            {t("footer.privacy")}
          </Link>
          <Link to={lp("/informacao-legal")} className="block mt-2 text-xs underline underline-offset-4 hover:text-white transition-colors" data-testid="footer-legal-link">
            {t("footer.legal_info")}
          </Link>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col gap-2 text-xs font-light">
          <span>© {new Date().getFullYear()} {SITE.legalName} {t("footer.rights")}</span>
          <span>NIF {SITE.nif}</span>
        </div>
      </div>
    </footer>
  );
}
